interface DataType {
   id: number;
   page: string;
   thumb: string;
   name: string;
   degisnation: string;
};

const inner_instructor_data: DataType[] = [
   {
      id: 1,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor01.png",
      name: "Sophia Ava",
      degisnation: "Digital Marketing",
   },
   {
      id: 2,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor02.png",
      name: "William Hope",
      degisnation: "Web Development",
   },
   {
      id: 3,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor03.png",
      name: "Ronald S. Staton",
      degisnation: "Ronald S. Staton",
   },
   {
      id: 4,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor04.png",
      name: "Dennis L. Turner",
      degisnation: "UX Design Lead",
   },
   {
      id: 5,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor05.png",
      name: "Timothy S. Reed",
      degisnation: "Digital Marketing",
   },
   {
      id: 6,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor06.png",
      name: "Barbara D. Rice",
      degisnation: "Barbara D. Rice",
   },
   {
      id: 7,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor07.png",
      name: "Olivia Mia",
      degisnation: "Web Design",
   },
   {
      id: 8,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor08.png",
      name: "Mark Jukarberg",
      degisnation: "UX Design Lead",
   },
   {
      id: 9,
      page: "inner_1",
      thumb: "/assets/img/instructor/instructor09.png",
      name: "Sandy J. Rankin",
      degisnation: "Web Development",
   },
];

export default inner_instructor_data;